interface TransparentSpacerProps {
    height: string
};

export const TransparentSpacer = ({ height }: TransparentSpacerProps ) => {
    return (
        <div className={`bg-transparent h-[${height}px]`}>
        </div>
    )
}